import { List, Card } from 'antd'
import { ExportOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'

import Box from '~/core/Box'
import Image from '~/core/Image'
import Link from '~/core/Link'
import Text from '~/core/Text'
import icons from '~/apps/consumer/icons'
import getColor from '~/lib/getColor'
import { isTeamsFeatureEnabled } from '~/redux-modules/identity'

import { CARD_LIST } from './constant'
import styles from './styles.css'

const PLACEMENT = 'premium-upsell-drawer-body'

type ListItemType = {
    title: string
    description: string
    icon: string
    link: string
}

export default function DrawerBody() {
    const isTeamsFeatureOn = useSelector(isTeamsFeatureEnabled)

    const RenderHeader = () => {
        return (
            <Text
                style={{
                    lineHeight: '20px',
                    fontWeight: 400,
                    color: getColor('blackAlpha65'),
                }}
                fontSize="12px"
            >
                {isTeamsFeatureOn ? 'LEARN ABOUT' : "WHAT'S INCLUDED"}
            </Text>
        )
    }
    const renderCard = ({ title, description, icon, link }: ListItemType) => {
        const name = title.split(' ').join('-')

        return (
            <List.Item style={{ borderBottom: 'none', padding: '4px 0' }}>
                <Link
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: getColor('blackAlpha65') }}
                    data-test-target={`link-${name}-${PLACEMENT}`}
                >
                    <Card
                        data-test-target={`card-item-${name}-${PLACEMENT}`}
                        style={{
                            alignItems: 'center',
                            color: getColor('blackAlpha65'),
                            justifyContent: 'space-between',
                        }}
                    >
                        <Box direction="row">
                            <Box direction="col" alignSelf="center">
                                <Image
                                    src={
                                        icons[
                                            icon as keyof typeof icons
                                        ] as string
                                    }
                                    width="36px"
                                />
                            </Box>
                            <Box direction="col" margin="0px 16px">
                                <Text
                                    fontSize="14px"
                                    data-test-target={`${name}-${PLACEMENT}`}
                                    style={{
                                        lineHeight: '22px',
                                        fontWeight: 400,
                                    }}
                                >
                                    {title}
                                </Text>
                                <Text
                                    fontSize="11px"
                                    style={{
                                        lineHeight: '16px',
                                        fontWeight: 400,
                                    }}
                                >
                                    {description}
                                </Text>
                            </Box>
                            <Box direction="col" alignSelf="center">
                                <ExportOutlined style={{ fontSize: '16px' }} />
                            </Box>
                        </Box>
                    </Card>
                </Link>
            </List.Item>
        )
    }

    return (
        <List
            dataSource={CARD_LIST}
            itemLayout="horizontal"
            renderItem={renderCard}
            style={{ margin: '5px', padding: '11px' }}
            header={<RenderHeader />}
            className={styles.listHeaderStyle}
        />
    )
}
